import { useHistory } from "react-router-dom";

// Redirect from one component to another component
const Redirect = (path) => {
  const history = useHistory();
  history.push(path);
};

export default Redirect;
